import { render, staticRenderFns } from "./verGrupos.vue?vue&type=template&id=6aeb93f7&scoped=true&"
import script from "./verGrupos.vue?vue&type=script&lang=js&"
export * from "./verGrupos.vue?vue&type=script&lang=js&"
import style0 from "./verGrupos.vue?vue&type=style&index=0&id=6aeb93f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb93f7",
  null
  
)

export default component.exports